import {
  generateSkinDefaults,
  cssPropertyToDefaultValueMap,
} from '@wix/editor-elements-panel';
import type { SkinDefinition } from '@wix/editor-elements-panel/src/adapters/types';

export const ProductSpecificationSkinDefinitionMap: Record<
  string,
  SkinDefinition
> = {
  'wixui.skins.ProductSpecification': {
    background: {
      type: 'BACKGROUND_FILL',
      defaultValue: cssPropertyToDefaultValueMap.background,
      state: 'regular',
    },
    'padding-bottom': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['padding-bottom'],
      state: 'regular',
    },
    'padding-top': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['padding-top'],
      state: 'regular',
    },
    'padding-left': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['padding-left'],
      state: 'regular',
    },
    'padding-right': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['padding-right'],
      state: 'regular',
    },
    'title-font': {
      type: 'FONT',
      defaultValue: cssPropertyToDefaultValueMap.font,
      state: 'regular',
    },
    'title-color': {
      type: 'CSS_COLOR',
      defaultValue: cssPropertyToDefaultValueMap.color,
      state: 'regular',
      paramName: 'color',
    },
    'title-padding-bottom': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['padding-bottom'],
      state: 'regular',
    },
    'title-padding-top': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['padding-top'],
      state: 'regular',
    },
    'title-padding-left': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['padding-left'],
      state: 'regular',
    },
    'title-padding-right': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['padding-right'],
      state: 'regular',
    },
    'group-font': {
      type: 'FONT',
      defaultValue: cssPropertyToDefaultValueMap.font,
      state: 'regular',
      paramName: 'font',
    },
    'group-color': {
      type: 'CSS_COLOR',
      defaultValue: cssPropertyToDefaultValueMap.color,
      state: 'regular',
      paramName: 'color',
    },
    'group-padding-bottom': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['padding-bottom'],
      state: 'regular',
    },
    'group-padding-top': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['padding-top'],
      state: 'regular',
    },
    'group-padding-left': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['padding-left'],
      state: 'regular',
    },
    'group-padding-right': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['padding-right'],
      state: 'regular',
    },
    'description-font': {
      type: 'FONT',
      defaultValue: cssPropertyToDefaultValueMap.font,
      state: 'regular',
      paramName: 'font',
    },
    'description-color': {
      type: 'CSS_COLOR',
      defaultValue: cssPropertyToDefaultValueMap.color,
      state: 'regular',
      paramName: 'color',
    },
    'description-padding-bottom': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['padding-bottom'],
      state: 'regular',
    },
    'description-padding-top': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['padding-top'],
      state: 'regular',
    },
    'description-padding-left': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['padding-left'],
      state: 'regular',
    },
    'description-padding-right': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['padding-right'],
      state: 'regular',
    },
  },
};

export default generateSkinDefaults(ProductSpecificationSkinDefinitionMap);
